namespace RedBullMOBILE360.SalesApp {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.SalesApp.WalletTransferDialog')
    export class WalletTransferDialog extends Serenity.EntityDialog<WalletTransferRow, any> {
        protected getFormKey() { return WalletTransferForm.formKey; }
        protected getIdProperty() { return WalletTransferRow.idProperty; }
        protected getLocalTextPrefix() { return WalletTransferRow.localTextPrefix; }
        protected getNameProperty() { return WalletTransferRow.nameProperty; }
        protected getService() { return WalletTransferService.baseUrl; }
        protected getDeletePermission() { return WalletTransferRow.deletePermission; }
        protected getInsertPermission() { return WalletTransferRow.insertPermission; }
        protected getUpdatePermission() { return WalletTransferRow.updatePermission; }

        protected form = new WalletTransferForm(this.idPrefix);
    }
}